var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.bannerData && _vm.bannerData.title))?_c('div',{staticClass:"banner"},[_c('h2',[_vm._v(_vm._s(_vm.bannerData.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.bannerData.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }